<template>
  <div class="dashboard-page">
    <h1 class="page-title">Dashboard</h1>
    <div class="sidesWrapper">
      <div style="width: 100%">
        <b-tabs nav-class="bg-transparent">
          <b-tab title="Permohonan" active>
            <div class="d-inline-block">
              <select
                v-model="filter_tahun"
                id="filter_tahun1"
                class="form-select"
              >
                <option v-for="d in optionTahun" :value="d">{{ d }}</option>
              </select>
            </div>

            <PermohonanMain :filter-tahun="filter_tahun" />

            <div class="row mt-4">
              <div class="col-12">
                <PermohonanProvChart :tahun="filter_tahun" />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <PermohonanSektorChart :tahun="filter_tahun" />
              </div>
            </div>
          </b-tab>

          <b-tab title="Penerbitan">
            <div class="d-inline-block">
              <select
                v-model="filter_tahun"
                id="filter_tahun2"
                class="form-select"
              >
                <option v-for="d in optionTahun" :value="d">{{ d }}</option>
              </select>
            </div>

            <IzinMain
              :data-penerbitan="dataPenerbitan"
              :filter_bulan="filter_bulan"
              @update:filter_bulan="loadCapaianPNBP"
              :filter-tahun="filter_tahun"
            />

            <div class="row mt-4">
              <div class="col-12">
                <IzinProvChart :tahun="filter_tahun" />
              </div>
            </div>

            <div class="row mt-4 g-3">
              <div class="col-12 col-lg-6">
                <IzinSektorChart :tahun="filter_tahun" />
              </div>
              <div class="col-12 col-lg-6">
                <IzinPNBPChart :tahun="filter_tahun" />
              </div>
            </div>
          </b-tab>

          <b-tab title="Pemutakhiran">
            <div class="d-inline-block">
              <select
                v-model="filter_tahun"
                id="filter_tahun1"
                class="form-select"
              >
                <option v-for="d in optionTahun" :value="d">{{ d }}</option>
              </select>
            </div>

            <PemutakhiranMain
              :data-pemutakhiran="dataPemutakhiran"
              :filter-tahun="filter_tahun"
            />

            <div class="row mt-4">
              <div class="col-12">
                <PemutakhiranPerubahanKkprl :tahun="filter_tahun" />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import IzinPNBPChart from './components/MainChartV2/IzinPNBPChart.vue'
import IzinProvChart from './components/MainChartV2/IzinProvChart.vue'
import IzinSektorChart from './components/MainChartV2/IzinSektorChart.vue'
import PermohonanProvChart from './components/MainChartV2/PermohonanProvChart.vue'
import PermohonanSektorChart from './components/MainChartV2/PermohonanSektorChart.vue'
import PermohonanMain from './components/MainChartV2/PermohonanMain.vue'
import IzinMain from './components/MainChartV2/IzinMain.vue'
import PemutakhiranMain from './components/MainChartV2/PemutakhiranMain.vue'
import PemutakhiranPerubahanKkprl from './components/MainChartV2/PemutakhiranPerubahanKkprl.vue'

export default {
  components: {
    PermohonanMain,
    PermohonanProvChart,
    PermohonanSektorChart,
    IzinMain,
    IzinProvChart,
    IzinSektorChart,
    IzinPNBPChart,
    PemutakhiranMain,
    PemutakhiranPerubahanKkprl,
  },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      filter_tahun: new Date().getFullYear(),
      filter_bulan: new Date().getMonth() + 1,
      dataPenerbitan: {
        sudah_pentek: 0,
        diterima_pentek: 0,
        ditolak_pentek: 0,
        belum_bayar_pnbp: 0,
        sudah_bayar_pnbp: 0,
        izin_terbit: 0,
        izin_persetujuan: 0,
        izin_konfirmasi: 0,
        izin_berusaha: 0,
        izin_nonberusaha: 0,
        capaian_pnbp: 0,
      },
      dataPemutakhiran: {
        jumlah_penerbitan_izin: 0,
        habis_masa_berlaku: 0,
        pencabutan: 0,
        pembatalan: 0,
      },
    }
  },
  methods: {
    async loadDataPenerbitan() {
      const configAxios = {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
      try {
        const res = (
          await axios.get(
            `${this.baseapi}api/dashboard/getJumlahPermohonanPentek?tahun=${this.filter_tahun}`,
            configAxios,
          )
        ).data.data
        const res2 = (
          await axios.get(
            `${this.baseapi}api/dashboard/getJumlahPermohonanPNBP?tahun=${this.filter_tahun}`,
            configAxios,
          )
        ).data.data
        const res3 = (
          await axios.get(
            `${this.baseapi}api/dashboard/getJumlahPenerbitanIzin?tahun=${this.filter_tahun}`,
            configAxios,
          )
        ).data.data
        this.dataPenerbitan = {
          ...this.dataPenerbitan,
          sudah_pentek: res.sudah_pentek,
          diterima_pentek: res.diterima,
          ditolak_pentek: res.ditolak,
          belum_bayar_pnbp: res2.belum_bayar,
          sudah_bayar_pnbp: res2.sudah_bayar,
          izin_terbit: res3.terbit,
          izin_persetujuan: res3.persetujuan,
          izin_konfirmasi: res3.konfirmasi,
          izin_berusaha: res3.berusaha,
          izin_nonberusaha: res3.nonberusaha,
        }
      } catch (error) {}
    },
    async loadCapaianPNBP(val) {
      if (val) this.filter_bulan = val
      const res = (
        await axios.get(
          `${this.baseapi}api/dashboard/getJumlahPNBP?tahun=${this.filter_tahun}&bulan=${this.filter_bulan}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
      ).data.data
      this.dataPenerbitan = {
        ...this.dataPenerbitan,
        capaian_pnbp: res,
      }
    },
    async loadDataPemutakhiran() {
      try {
        const res = await axios.get(
          `${this.baseapi}api/dashboard/getJumlahPemuktahiran?tahun=${this.filter_tahun}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        this.dataPemutakhiran = res.data.data
      } catch (error) {}
    },
  },
  computed: {
    optionTahun() {
      const currentYear = new Date().getFullYear()
      return Array.from({ length: 10 }, (_, i) => currentYear - i)
    },
  },
  watch: {
    filter_tahun: {
      async handler() {
        this.loadDataPenerbitan()
        this.loadCapaianPNBP()
        this.loadDataPemutakhiran()
      },
      immediate: true,
    },
  },
}
</script>

<style src="./Dashboard.scss" lang="scss" />
